<template>
  <div id="app">
    <div class="nav">
      <a href="#" v-if="state=='settings' || state=='journey'" @click="state='settings'">Questions</a>
      <span v-if="state=='settings' || state=='journey'"> | </span>
      <a href="#" v-if="state=='settings' || state=='journey'" @click="state='journey'">Dashboard</a>
    </div>
    <settings-screen @start="start($event)" v-if="state=='settings'"></settings-screen>
    <journey-screen @start="start($event)" v-if="state=='journey'"></journey-screen>
    <quiz-screen @back="setState($event)" :questions="questions" :paid="paid" :start="dateStart" v-if="state=='quiz'"></quiz-screen>
  </div>
</template>

<script>
import Settings from './Settings.vue'
import Journey from './Journey.vue'
import Quiz from './Quiz.vue'
export default {
  name: 'app',
  components: {
    'settings-screen': Settings,
    'journey-screen': Journey,
    'quiz-screen': Quiz
  },
  methods:{
    setState: function(){
      var vm = this;
      vm.state='settings';
    },
    start: function(data){
      var vm = this;

      vm.$http.get('https://biolympiads.com/wp-json/bioquiz/v1/questions?json='+encodeURIComponent(JSON.stringify(data))).then(response => {

        vm.questions = response.data

        for(var i = 0; i < vm.questions.length; i++){
          if(vm.questions[i].type == 'drag_and_match' || vm.questions[i].type == 'multi_drag_and_match'){
            for(var j = 0; j < vm.questions[i].drag_and_match.length; j++ ){
              console.log(i, j, vm.questions[i])
              vm.questions[i].drag_and_match[j].answer = [];
            }
          }
        }
        vm.state='quiz'
        vm.dateStart = new Date()
        console.log(response.data);
      }, response => {
        console.error(response);
      });
      // vm.state = 'quiz';
      console.log('got start', data, JSON.stringify(data));
    }
  },
  data () {
    return {
      dateStart: false,
      state: 'settings',
      questions: [],
      paid: false,
      startDate: false,
    }
  },
  mounted: function(){
      var vm = this;
      vm.$http.get('https://biolympiads.com/wp-json/bioquiz/v1/membership').then(response => {

        if(response.data != null){
          vm.paid = true;
        }

      });
  },
}
</script>

<style lang="scss">

.nav {
  margin-bottom: 15px;
}

/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}*/
</style>



// WEBPACK FOOTER //
// App.vue?002b8268